import { Component, OnInit, ViewChild } from '@angular/core';
import { DashboardService } from '../service/dashboard.service';
import { Router } from '@angular/router';
import { MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { UpdateAdminComponent } from 'src/app/dialogs/update-admin/update-admin.component';
import Swal, { SweetAlertResult } from 'sweetalert2';

@Component({
  selector: 'app-managerstbl',
  templateUrl: './managerstbl.component.html',
  styleUrls: ['./managerstbl.component.scss']
})
export class ManagerstblComponent implements OnInit {

  userdata;
  managerinfo: any = []
  searchdata;


  length: number
  pageSize: number = 5
  pageSizeOptions = [5, 10, 20, 50, 100]

  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource();
  displayedColumns = ['id', 'firstName', 'lastName', 'email', 'phone', 'role', 'edit', 'reset']
  private _snackBar: any;
  dialogRef: any;

  constructor(
    public service: DashboardService,
    public router: Router,
    private dialog: MatDialog) { }


  ngOnInit() {
    this.userdata = JSON.parse(localStorage.getItem('userdata'))
    this.fetchManagers()
  }


  fetchManagers() {
    Swal.showLoading();;
    this.service.getManagers(this.userdata.email, this.userdata.role).subscribe(data => {
      this.managerinfo = data;
      this.dataSource.data = this.managerinfo;
      this.dataSource.paginator = this.paginator;
      Swal.close();
    })
  }

  search(query: string) {
    this.searchdata = (query) ? this.managerinfo.filter(data => data.manager_id.toLowerCase().includes(query.toLowerCase()) || data.lastName.toLowerCase().includes(query.toLowerCase()) || data.firstName.toLowerCase().includes(query.toLowerCase()) || data.email.toUpperCase().includes(query.toUpperCase())) : this.managerinfo;
  }

  registermanager() {
    this.router.navigate(['/signupmanager'])
  }

  allmanagers() {
    this.router.navigate(['/allmanagers'])
  }

  openEditDialog(selectedRow) {
    console.log(selectedRow);

    const dialogRef = this.dialog.open(UpdateAdminComponent, {
      disableClose: true,
      data: selectedRow
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'updated') {
        this.fetchManagers();
      }
    });
  }


  //confirm login Password to continue
  confirmPassword(element) {
    (Swal as any).fire({
      icon: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      text: "Do you really want to reset this user's password?",
      reverseButtons: true
    }).then((result: SweetAlertResult) => {
      if (result.value) {
        (Swal as any).fire({
          //title: "Identity Confirmation",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          inputPlaceholder: "Confirm your Password",
          input: "password",
          reverseButtons: true
        })
          .then((result: SweetAlertResult) => {
            if (result.value) {
              Swal.showLoading();
              this.service.getLogin({
                email: this.userdata.email,
                password: result.value,
                role: 'admin'
              })
                .toPromise()
                .then((responseData: any) => {
                  Swal.close();
                  if (responseData.hasOwnProperty('responseCode') && responseData.responseCode === '000') {

                    this.resetAdminPassword(element)

                  }
                  else {
                    (Swal as any).fire({
                      title: 'Wrong credentials!',
                      text: 'Please check and try again',
                      icon: 'error',
                    });
                    setTimeout(() => { this.confirmPassword(element) }, 2000);
                  }

                }).catch(error => {
                  (Swal as any).fire({
                    title: 'Connection Failed!',
                    text: 'Login Failed',
                    icon: 'error',
                  });
                  setTimeout(() => { this.confirmPassword(element) }, 2000);
                })
            }
            else
              this.alertSnackBar('No Password was entered', 'User Not Verified');
          });
      }
    })

  }
  //trigger the snackbar
  alertSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }



  resetAdminPassword(element) {
    this.service.resetPassword({ email: element.email })
      .toPromise()
      .then((response: any) => {
        if (response.responseCode == '000') {
          (Swal as any).fire({
            title: 'Successful',
            text: `A default password has been mailed to (${element.email}). Please advise the user to change the password after login`,
            icon: 'success',
          });

          setTimeout(() => {
            this.dialogRef.close();
          }, 10000);
        }
        else if (response.hasOwnProperty('responseMessage'))
          (Swal as any).fire({
            title: 'Failed',
            text: response.responseMessage,
            icon: 'error',
          });
        else
          (Swal as any).fire({
            title: 'Failed',
            text: 'Reset Password Failed!',
            icon: 'error',
          });
      })
      .catch(error => {
        (Swal as any).fire({
          title: 'Failed',
          text: 'Password Reset Failed!',
          icon: 'error',
        });
      })

  }

}
